import { Slice, createSlice, PayloadAction } from "@reduxjs/toolkit";

export type SalesReportProps = {
  totalOrderCount: number;
  totalAmount: number;
};

export type DashboardSliceProps = {
  todaySales: SalesReportProps | null;
  monthlySales: SalesReportProps | null;
  weeklySales: SalesReportProps | null;
  todayIsloading: boolean;
  monthlyIsloading: boolean;
  weeklyIsloading: boolean;
};

const initialState: DashboardSliceProps = {
  todaySales: null,
  monthlySales: null,
  weeklySales: null,
  todayIsloading: true,
  monthlyIsloading: true,
  weeklyIsloading: true,
};

const dashboardSlice: Slice<DashboardSliceProps> = createSlice({
  name: "dashboardSlice",
  initialState,
  reducers: {
    setTodaySales: (state, action: PayloadAction<SalesReportProps | null>) => {
      state.todaySales = action.payload;
    },
    setMonthlySales: (state, action: PayloadAction<SalesReportProps | null>) => {
      state.monthlySales = action.payload;
    },
    setWeeklySales: (state, action: PayloadAction<SalesReportProps | null>) => {
      state.weeklySales = action.payload;
    },
    setTodaySalesLoading: (state, action: PayloadAction<boolean>) => {
      state.todayIsloading = action.payload;
    },
    setMonthlySalesLoading: (state, action: PayloadAction<boolean>) => {
      state.monthlyIsloading = action.payload;
    },
    setWeeklySalesLoading: (state, action: PayloadAction<boolean>) => {
      state.weeklyIsloading = action.payload;
    },
  },
});

export const {
  setTodaySales,
  setMonthlySales,
  setWeeklySales,
  setTodaySalesLoading,
  setMonthlySalesLoading,
  setWeeklySalesLoading,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
